import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col w-full" };
const _hoisted_2 = { class: "flex flex-row my-2 text-gray-400 items-center" };
const _hoisted_3 = { class: "flex flex-row my-2 text-gray-400 items-center" };
const _hoisted_4 = { class: "flex flex-row text-gray-400 items-center" };
import { appState } from '@/composable/appState';
import { CHAT_WIDGET_IDS, ChatWidgetSettingsDataOptions, FallBackTimeOptions, } from '@/helper/const';
import { updateChatWidgetSetting } from '@/helper/helper';
import { i18n } from '@/plugin/vue-i18n';
import { InfoCircleIcon } from '@gohighlevel/ghl-icons/24/outline';
import { UIFormItem, UIInput, UISelect, UISwitch, UITooltip, } from '@gohighlevel/ghl-ui';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LiveChatAssigned',
    setup(__props) {
        const handleEnableContactForm = (val) => {
            appState.chatWidgetSettingsData.advanceSettings.enableContactForm = val;
            appState.unsavedChanges = true;
        };
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(UIFormItem), {
                    label: _ctx.$t('sidebar.liveChatMessage'),
                    "show-feedback": false,
                    class: "my-2"
                }, {
                    default: _withCtx(() => {
                        var _a, _b, _c, _d;
                        return [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_unref(UISwitch), {
                                        rubberBand: false,
                                        value: (_b = (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.advanceSettings) === null || _b === void 0 ? void 0 : _b.enableContactForm,
                                        "onUpdate:value": handleEnableContactForm
                                    }, null, 8 /* PROPS */, ["value"]),
                                    _createVNode(_unref(UIFormItem), {
                                        label: _ctx.$t('sidebar.enableContactForm'),
                                        "show-feedback": false,
                                        class: "ml-2 mt-1"
                                    }, null, 8 /* PROPS */, ["label"]),
                                    _createVNode(_unref(UITooltip), {
                                        trigger: "hover",
                                        style: { "width": "400px" },
                                        placement: "right"
                                    }, {
                                        trigger: _withCtx(() => [
                                            _createVNode(_unref(InfoCircleIcon), { class: "w-6 h-4" })
                                        ]),
                                        default: _withCtx(() => [
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('sidebar.enableContactFormHelper')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _createElementVNode("div", _hoisted_3, [
                                    _createVNode(_unref(UISwitch), {
                                        rubberBand: false,
                                        value: ((_c = _unref(appState).chatWidgetSettingsData) === null || _c === void 0 ? void 0 : _c.showLiveChatWelcomeMsg) || false,
                                        "onUpdate:value": _cache[0] || (_cache[0] =
                                            val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).SHOW_LIVE_CHAT_WELCOME_MSG, val))
                                    }, null, 8 /* PROPS */, ["value"]),
                                    _createVNode(_unref(UIFormItem), {
                                        label: _ctx.$t('sidebar.showLiveChatWelcomeMsg'),
                                        "show-feedback": false,
                                        class: "ml-2 mt-1"
                                    }, null, 8 /* PROPS */, ["label"]),
                                    _createVNode(_unref(UITooltip), {
                                        trigger: "hover",
                                        placement: "right"
                                    }, {
                                        trigger: _withCtx(() => [
                                            _createVNode(_unref(InfoCircleIcon), { class: "w-6 h-4" })
                                        ]),
                                        default: _withCtx(() => [
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('sidebar.showLiveChatFeedbackHelper')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                (_unref(appState).chatWidgetSettingsData.showLiveChatWelcomeMsg === true)
                                    ? (_openBlock(), _createBlock(_unref(UIInput), {
                                        key: 0,
                                        placeholder: _ctx.$t('sidebar.liveChatMessage'),
                                        rows: 4,
                                        type: "textarea",
                                        id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                        modelValue: (_d = _unref(appState).chatWidgetSettingsData) === null || _d === void 0 ? void 0 : _d.liveChatIntroMsg,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] =
                                            val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).LIVE_CHAT_INTRO_MSG, val))
                                    }, null, 8 /* PROPS */, ["placeholder", "id", "modelValue"]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ];
                    }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_unref(UIFormItem), {
                        label: _ctx.$t('sidebar.fallBackSubAccountUserInactivityTime'),
                        "show-feedback": false,
                        class: "mt-1"
                    }, null, 8 /* PROPS */, ["label"]),
                    _createVNode(_unref(UITooltip), {
                        trigger: "hover",
                        placement: "left",
                        style: { "width": "400px" }
                    }, {
                        trigger: _withCtx(() => [
                            _createVNode(_unref(InfoCircleIcon), { class: "w-6 h-4" })
                        ]),
                        default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('sidebar.fallBackSubAccountUserInactivityTimeHelper')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _createVNode(_unref(UISelect), {
                    id: "select-id",
                    value: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.liveChatUserInactiveTime,
                    options: _unref(FallBackTimeOptions),
                    clearable: false,
                    type: "default",
                    resetMenuOnOptionsChange: true,
                    placeholder: "Select one",
                    "onUpdate:value": _cache[2] || (_cache[2] =
                        val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).LIVE_CHAT_USER_INACTIVE_TIME, val))
                }, null, 8 /* PROPS */, ["value", "options"]),
                _createVNode(_unref(UIFormItem), {
                    label: _ctx.$t('sidebar.fallBackSubAccountUserInactivityMessage'),
                    "show-feedback": false,
                    class: "my-2"
                }, {
                    default: _withCtx(() => {
                        var _a;
                        return [
                            _createVNode(_unref(UIInput), {
                                rows: 4,
                                type: "textarea",
                                id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                modelValue: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.liveChatUserInactiveMsg,
                                placeholder: _unref(i18n).global.t('placeholder.liveChatUserInactiveMsg'),
                                "onUpdate:modelValue": _cache[3] || (_cache[3] =
                                    val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).LIVE_CHAT_USER_INACTIVE_MSG, val))
                            }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                        ];
                    }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" <UIFormItem\n    :label=\"$t('sidebar.representativeAssignedMessage')\"\n    :show-feedback=\"false\"\n    class=\"my-2\"\n  >\n    <UIInput\n      type=\"textarea\"\n      :id=\"CHAT_WIDGET_IDS.CHAT_WIDGET_LABEL_INPUT\"\n      :modelValue=\"\n        appState.chatWidgetSettingsData?.representativeAssignedMessage\n      \"\n      @update:modelValue=\"\n        val =>\n          updateChatWidgetSetting(\n            ChatWidgetSettingsDataOptions.REPRESENTATIVE_ASSIGNED_MESSAGE,\n            val\n          )\n      \"\n    />\n  </UIFormItem> ")
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
